import LinkTo from "./LinkTo";

export default LinkTo;



/** WEBPACK FOOTER **
 ** ./src/components/Amazon/LinkTo/index.js
 **/